var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.text.split('{break}')),function(line,lineNumber){return _c('p',{key:lineNumber},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.replaceLink(line))}}),_c('br')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }